import { Guard } from 'runtypes';

export const createEnumGuard = <T extends number | string>(values: readonly T[]) => {
	return Guard((value: unknown): value is T => values.includes(value as T));
};
